import { render } from "./IntegrationsPage.vue?vue&type=template&id=12f0f6f5&scoped=true"
import script from "./IntegrationsPage.vue?vue&type=script&lang=js"
export * from "./IntegrationsPage.vue?vue&type=script&lang=js"

import "./IntegrationsPage.vue?vue&type=style&index=0&id=12f0f6f5&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f0f6f5"]])

export default __exports__